//var filterObjectsByKV = require('../services/urbiplanapi-extensions/urbiplanapi.filter.js');


module.exports = function(env){
    env.opts.autoescape = false;
    
	return env;
    // env.addExtension(...) etc
}


